'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = require('../../helper/utils');

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

var _style = require('./style');

var _dofSpinner = require('../dof-spinner');

var _dofSpinner2 = _interopRequireDefault(_dofSpinner);

var _utils2 = require('../utils');

var _utils3 = _interopRequireDefault(_utils2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 带switch按钮的cell
var animation = weex.requireModule('animation');
exports.default = {
  components: { DofSpinner: _dofSpinner2.default },
  mixins: [_colmo2.default, _diablo2.default],
  props: {
    checked: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    isLightLoading: {
      type: Boolean,
      default: false
    },
    blindHelptext: {
      type: String,
      default: ''
    },
    borderColor: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    isScale: {
      typeof: Boolean,
      default: undefined
    },
    dotColor: {
      typeof: String,
      default: ''
    }
  },
  computed: {
    loadingSrc: function loadingSrc() {
      if (this._isColmo || this.type === 'colmo') return 'colmo';
      var src = this.isLightLoading ? 'white' : 'black';
      return src;
    },
    switchActiveClass: function switchActiveClass() {
      var type = this.type;

      return 'switch-active-' + type;
    },
    mrSwitchStyle: function mrSwitchStyle() {
      return this.disabled ? { opacity: 0.3 } : this.loading ? { opacity: 0 } : { opacity: 1 };
    },
    dotStyle: function dotStyle() {
      return {
        // 安卓1px渲染误差
        top: weex.config.env.platform.toLowerCase() === 'android' ? '1px' : '0px'
      };
    },
    customStyle: function customStyle() {
      var res = {};
      if (this.checked) {
        res = this._isDiablo ? _extends({}, _style.STYLE_MAP_DIABLO[this.type]) : _extends({}, _style.STYLE_MAP[this.type]) || {};
      } else {
        res = {
          'border-color': 'transparent',
          'background-color': this._isDiablo ? '#45494C' : '#d3d5d7'
        };
      }
      // colmo
      if (this._isColmo && this.type === 'default' || this.type === 'colmo') {
        res.borderColor = this.checked ? '#B35336' : '#71717A';
        res.backgroundColor = 'transparent';
      }

      if (this.borderColor) res.borderColor = this.borderColor;
      if (this.backgroundColor) res.backgroundColor = this.backgroundColor;
      return res;
    },
    _dotColor: function _dotColor() {
      var dotColor = '';
      if (this.checked) {
        dotColor = this.type === 'white' ? '#1E2E37' : '#ffffff';
        // colmo
        if (this._isColmo && this.type === 'default' || this.type === 'colmo') dotColor = '#B35336';
        if (this.dotColor) dotColor = this.dotColor;
      } else {
        dotColor = this.type === 'white' ? '#ffffff' : this._isColmo ? '#8A8A8F' : this._isDiablo ? '#DCDDDD' : '#ffffff';
      }

      return dotColor;
    },
    _isScale: function _isScale() {
      var isScale = true;
      if (this._isColmo && this.type === 'default' || this.type === 'colmo') isScale = false;
      if (this.isScale !== undefined) isScale = this.isScale;
      return isScale;
    },
    leftDotStyle: function leftDotStyle() {
      return {
        transform: !this._isScale ? 'translateX(2px) scale(' + (this._isColmo || this.type === 'colmo' ? 2 : 2.25) + ')' : 'translateX(2px) scale(2.25)',
        backgroundColor: this._dotColor
      };
    },
    rightDotStyle: function rightDotStyle() {
      var offset = 46;
      if (this._isColmo && this.type === 'default' || this.type === 'colmo') offset = 50;
      if (_utils3.default.env.isWeb()) offset = 46;
      return {
        backgroundColor: this._dotColor,
        transform: 'translateX(' + offset + 'px) scale(2.25)'
      };
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.handleInit();
  },

  methods: {
    handleInit: function handleInit() {
      if (this.checked) {
        animation && animation.transition(this.$refs.switchDot, {
          styles: this.rightDotStyle,
          duration: 0
        });
      } else {
        animation && animation.transition(this.$refs.switchDot, {
          styles: this.leftDotStyle,
          duration: 0
        });
      }
    },

    changeHandler: (0, _utils.throttle)(function () {
      var disabled = this.disabled;

      if (!disabled) {
        this.$emit('dofChange');
      }
    }, 300)
  },
  watch: {
    _isColmo: function _isColmo() {
      var _this = this;

      setTimeout(function () {
        _this.handleInit();
      }, 0);
    },
    checked: function checked(newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        animation && animation.transition(this.$refs.switchDot, {
          styles: this.rightDotStyle,
          duration: 300,
          timingFunction: 'ease-out'
        });
      } else if (newVal === false && oldVal === true) {
        animation && animation.transition(this.$refs.switchDot, {
          styles: this.leftDotStyle,
          duration: 300,
          timingFunction: 'ease-out'
        });
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-switch/index.vue
// module id = 408
// module chunks = 0 1